import c from "../../utils/constants";

class FlowController {
  constructor(MermaidService, $scope) {
    'ngInject';

    this.mermaidService = MermaidService;
    this.$scope = $scope;
  }

  $onInit() {

    this.mermaidService.init();

    this.treeViewOptions = {
      dataSource: [{
        text: "Flow Diagrams",
        expanded: true,
        items: [
          { 
            text: "Bot",
            expanded: true,
            items: [
              // { id: c.flowDiagrams.SMS_CHANNEL, text: "SMS Channel" },
              { id: c.flowDiagrams.FACEBOOK_CHANNEL, text: "Helper Flow v1.1", selected: true },
              { id: c.flowDiagrams.LOCATE_HELPERS_IN_AREA_FLOW, text: "Locate Helpers In Area Flow" },
              { id: c.flowDiagrams.POST_JOB_FLOW, text: "Post Job Flow" },
              { id: c.flowDiagrams.DISPLAY_PROFILE_FLOW, text: "Display Profile Flow" }
            ]
          },
          {
            text: "Jobs",
            items: [
              { id: c.flowDiagrams.BABYSITTING_JOB, text: "Babysitting Job" },
              { id: c.flowDiagrams.RECURRING_JOB, text: "Recurring Job" },
            ]
          }
        ]
      }],
      select: (e) => this.onTreeViewSelect(e),
    }

    this.renderGraph(c.flowDiagrams.FACEBOOK_CHANNEL);
  }

  onTreeViewSelect(e) {
    let treeview = $("#flow-tree-view").data("kendoTreeView");
    let dataItem = treeview.dataItem(e.node);

    if(dataItem.id)
      this.renderGraph(dataItem.id);
  }
  
  renderGraph(id) {
    this.setHeader(id);
    const graphData = this.mermaidService.getGraph(id);

    this.mermaidService.render(`graph-${id}`, graphData, (svg, bindingFunctions)=> {
      document.getElementById("graph").innerHTML = svg;
    });
  }

  setHeader(id) {
    let header = "";
    switch(id) {
      case c.flowDiagrams.LOCATE_HELPERS_IN_AREA_FLOW: 
        header = "Locate Helpers in Area Flow";
        break;
      case c.flowDiagrams.POST_JOB_FLOW:
        header = "Post Job Flow";
        break;
      case c.flowDiagrams.DISPLAY_PROFILE_FLOW:
        header = "Display Profile Flow";
        break;
      case c.flowDiagrams.BABYSITTING_JOB:
        header = "Babysitting Job";
        break;
      case c.flowDiagrams.RECURRING_JOB:
        header = "Recurring Job";
        break;
      case c.flowDiagrams.FACEBOOK_CHANNEL:
        header = "Helper Flow v1.1";
        break;
    }

    setTimeout(() => {
      this.header = header;
      this.$scope.$apply();
    }, 0);
  }

}

export default FlowController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/flow/flow.controller.js
 **/